import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-depositescheme',
  templateUrl: './depositescheme.component.html',
  styleUrls: ['./depositescheme.component.css']
})
export class DepositeschemeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
